// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c4668eaa","455":"bcbb5899","977":"1d547a67"}[chunkId] + ".chunk.js";
};